import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { formatImgUrl } from "../../../../../utils/cardFormating";
import { Media } from "../../../../../types/types/common.types";

interface MediaPreviewProps {
  item: Media;
  onRemove: () => void;
}

const styles = {
  container: {
    width: "fit-content",
    position: "relative",
    borderRadius: "8px",
  },
  image: {
    width: "160px",
    height: "160px",
    objectFit: "cover",
  },
  video: {
    width: "160px",
    height: "160px",
  },
  removeButton: {
    position: "absolute",
    top: 4,
    right: 4,
    padding: "4px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
    },
  },
};

export const MediaPreview = ({ item, onRemove }: MediaPreviewProps) => {
  return (
    <Box sx={styles.container}>
      {item.type === "IMAGE" ? (
        <Box component="img" src={formatImgUrl(item.url)} alt="" sx={styles.image} />
      ) : (
        <Box component="video" src={formatImgUrl(item.url)} controls sx={styles.video} />
      )}
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        sx={styles.removeButton}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
